import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const BadgeMeta: ComponentMeta = {
  componentName: "Badge",
  package: "@mijadesign/web",
  title: "徽标",
  description: "用于展示新消息数量或状态标记",
  category: ComponentCategory.DATA_DISPLAY,
  icon: "NotificationOutlined",
  canHaveChildren: false,
  props: [
    {
      name: "count",
      label: "数量",
      type: PropType.NUMBER,
      defaultValue: 0,
      group: "内容",
    },
    {
      name: "overflowCount",
      label: "溢出数量",
      type: PropType.NUMBER,
      defaultValue: 99,
      group: "内容",
    },
    {
      name: "showZero",
      label: "显示零",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "展示",
    },
    {
      name: "dot",
      label: "红点模式",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "样式",
    },
    {
      name: "status",
      label: "状态",
      type: PropType.ENUM,
      options: [
        { label: "无", value: "" },
        { label: "成功", value: "success" },
        { label: "处理中", value: "processing" },
        { label: "错误", value: "error" },
        { label: "默认", value: "default" },
        { label: "警告", value: "warning" },
      ],
      group: "样式",
    },
    {
      name: "color",
      label: "自定义颜色",
      type: PropType.STRING,
      group: "样式",
    },
    {
      name: "text",
      label: "状态文字",
      type: PropType.STRING,
      group: "内容",
    },
    {
      name: "offset",
      label: "偏移量",
      type: PropType.ARRAY,
      description: "设置偏移量，格式：[x, y]",
      group: "位置",
    },
  ],
  defaultProps: {
    count: 0,
    overflowCount: 99,
  },
  npm: {
    package: "@mijadesign/web",
    exportName: "Badge",
  },
  snippet: {
    componentName: "Badge",
    package: "@mijadesign/web",
    props: { count: 5 },
  },
};

export const BadgeRibbonMeta: ComponentMeta = {
  componentName: "Badge.Ribbon",
  package: "@mijadesign/web",
  title: "缎带",
  description: "用于包裹元素的缎带标签",
  category: ComponentCategory.DATA_DISPLAY,
  icon: "PushpinOutlined",
  canHaveChildren: true,
  props: [
    {
      name: "text",
      label: "缎带文本",
      type: PropType.STRING,
      group: "内容",
    },
    {
      name: "color",
      label: "颜色",
      type: PropType.STRING,
      group: "样式",
    },
    {
      name: "placement",
      label: "位置",
      type: PropType.ENUM,
      defaultValue: "end",
      options: [
        { label: "起点", value: "start" },
        { label: "终点", value: "end" },
      ],
      group: "位置",
    },
  ],
  defaultProps: {
    placement: "end",
  },
  npm: {
    package: "@mijadesign/web",
    exportName: "Badge",
  },
  snippet: {
    componentName: "Badge.Ribbon",
    package: "@mijadesign/web",
    props: { text: "缎带" },
  },
};
